import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { changesSlice, changesSubslice } from "redux/features/changes";
import { RESOURCE_TYPE_EMAIL_ADDRESS, NEW_RESOURCE } from "redux/typeConstants";

export function useEmailChangesInProgress(id, settingNewPrimary) {
  const allChangeRecords = useSelector(changesSlice.selector);
  const partialAddition = changesSubslice(
    allChangeRecords,
    id,
    "email",
    RESOURCE_TYPE_EMAIL_ADDRESS,
    NEW_RESOURCE
  );

  // If we are adding a new address in the "Primary" slot (where the
  // editing is displayed on the main e-mail page rather than by on a
  // subsidiary "Adding new E-mail" page):

  //   * Don't report this as "additionalAddressBeingAdded", since that is
  //     used as an indication that there is a subsidiary page still in
  //     progress.

  //   * And, don't clear out any partial change record that doesn't yet
  //     have a valid e-mail address entered, the way we do for not-yet-
  //     started new-address additions on subsidiary pages.

  const additionalAddressBeingAdded =
    partialAddition &&
    partialAddition.changes.address &&
    partialAddition.changes.address.includes("@") &&
    !settingNewPrimary
      ? partialAddition.changes.address
      : null;

  const dispatch = useDispatch();
  const cancelUnfinishedAddition = () => {
    dispatch(
      changesSlice.actions.deleteChangeRecord({
        id: id,
        section: "email",
        resourceType: RESOURCE_TYPE_EMAIL_ADDRESS,
        resourceId: NEW_RESOURCE,
      })
    );
  };

  useEffect(() => {
    if (partialAddition && !settingNewPrimary && !additionalAddressBeingAdded)
      cancelUnfinishedAddition();
  });

  return {
    emailChangeRecords: changesSubslice(
      allChangeRecords,
      id,
      "email",
      RESOURCE_TYPE_EMAIL_ADDRESS
    ),
    additionalAddressBeingAdded,
    cancelUnfinishedAddition,
  };
}
